import Flickity from 'flickity'

export default (id) => ({
    init() {
        const flkty = new Flickity(this.$el, {
            cellAlign: 'center',
            prevNextButtons: false,
            pageDots: false,
            wrapAround: true,
            watchCSS: true,
        })

        console.log('FLKTY', flkty)
    },
})
